// <zzy-header module="..."></zzy-header>
// Apple × Tesla DNA · glass nav fixa · logo oficial ZZYON
import { getAuthContext, signOut } from '../auth.js';
import { escapeHtml } from '../utils.js';

class ZzyHeader extends HTMLElement {
  static get observedAttributes() { return ['module']; }

  async connectedCallback() {
    if (this._mounted) return;
    this._mounted = true;
    const ctx = await getAuthContext();
    this._render(ctx);
    this._bindHandlers();
  }

  _render(ctx) {
    const tenant = ctx.tenant;
    const user = ctx.user;
    const branding = tenant?.branding || {};
    const moduleName = this.getAttribute('module') || 'Torre';
    const tenantLabel = (branding.app_name || tenant?.nome || '').toUpperCase().replace(/^TORRE\s+/i, '').trim();

    this.innerHTML = `
      <style>
        zzy-header {
          display: block;
          position: sticky; top: 0; z-index: 100;
          background: rgba(10, 14, 39, 0.72);
          backdrop-filter: saturate(180%) blur(20px);
          -webkit-backdrop-filter: saturate(180%) blur(20px);
          border-bottom: 1px solid var(--zzy-border);
        }
        zzy-header .zzy-nav {
          display: flex; align-items: center; justify-content: space-between;
          max-width: 1500px; margin: 0 auto;
          padding: 14px 28px;
          gap: 24px;
        }
        zzy-header .left { display: flex; align-items: center; gap: 24px; min-width: 0; }
        zzy-header .module-tag {
          display: flex; flex-direction: column; line-height: 1;
          padding-left: 16px; border-left: 1px solid var(--zzy-border-strong);
          min-width: 0;
        }
        zzy-header .module-tag .label {
          font: 600 9px/1 var(--zzy-font);
          letter-spacing: 3px;
          color: var(--zzy-text-mute);
          text-transform: uppercase;
          margin-bottom: 6px;
        }
        zzy-header .module-tag .name {
          font: 600 14px/1 var(--zzy-font);
          color: var(--zzy-mist);
          letter-spacing: -0.005em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        zzy-header nav.modules {
          display: flex; gap: 4px;
          padding: 4px;
          background: rgba(255,255,255,0.03);
          border: 1px solid var(--zzy-border);
          border-radius: 999px;
        }
        zzy-header nav.modules a {
          font: 500 12px/1 var(--zzy-font);
          color: var(--zzy-text-mute);
          padding: 7px 14px;
          border-radius: 999px;
          transition: color var(--zzy-fast), background var(--zzy-fast);
        }
        zzy-header nav.modules a:hover { color: var(--zzy-mist); background: rgba(255,255,255,0.04); }
        zzy-header nav.modules a.active {
          color: var(--zzy-mist);
          background: var(--zzy-sky-soft);
          border: 1px solid rgba(59,110,255,0.22);
        }
        zzy-header .right { display: flex; align-items: center; gap: 16px; }
        zzy-header .user-pill {
          display: flex; align-items: center; gap: 10px;
          padding: 6px 12px 6px 6px;
          background: rgba(255,255,255,0.03);
          border: 1px solid var(--zzy-border);
          border-radius: 999px;
        }
        zzy-header .avatar {
          width: 28px; height: 28px; border-radius: 50%;
          background: var(--zzy-sky);
          display: flex; align-items: center; justify-content: center;
          font: 700 11px/1 var(--zzy-font); color: #FFFFFF;
        }
        zzy-header .user-email {
          font: 500 12px/1 var(--zzy-font);
          color: var(--zzy-text-mute);
          max-width: 180px;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }
        zzy-header button.logout {
          background: transparent;
          border: 1px solid var(--zzy-border);
          color: var(--zzy-text-mute);
          padding: 7px 14px;
          border-radius: 999px;
          cursor: pointer;
          font: 500 12px/1 var(--zzy-font);
          transition: color var(--zzy-fast), border-color var(--zzy-fast);
        }
        zzy-header button.logout:hover { color: var(--zzy-mist); border-color: var(--zzy-border-strong); }
        @media (max-width: 900px) {
          zzy-header nav.modules { display: none; }
          zzy-header .module-tag .label { display: none; }
        }
      </style>

      <div class="zzy-nav">
        <div class="left">
          <a href="https://app.zzyon.com" style="color:var(--zzy-mist)">
            <zzy-logo size="28" sub="false"></zzy-logo>
          </a>
          <div class="module-tag">
            <span class="label">${escapeHtml(tenantLabel || 'Torre')}</span>
            <span class="name">${escapeHtml(moduleName)}</span>
          </div>
        </div>

        <nav class="modules">
          <a href="https://briefing.zzyon.com" data-mod="briefing">Briefing</a>
          <a href="https://ra.zzyon.com" data-mod="ra">RA</a>
          <a href="https://cargas.zzyon.com" data-mod="cargas">Cargas</a>
          <a href="https://comercial.zzyon.com" data-mod="comercial">Comercial</a>
          <a href="https://inbox.zzyon.com" data-mod="inbox">Inbox</a>
        </nav>

        <div class="right">
          ${user ? `
            <div class="user-pill" title="${escapeHtml(user.email || '')}">
              <div class="avatar">${escapeHtml(((user.email || '?')[0] || '?').toUpperCase())}</div>
              <span class="user-email">${escapeHtml(user.email || '')}</span>
            </div>
            <button class="logout" id="logout">Sair</button>
          ` : ''}
        </div>
      </div>
    `;

    // Marca módulo ativo na nav
    const host = location.hostname;
    const activeMod = host.split('.')[0];
    this.querySelectorAll('nav.modules a').forEach(a => {
      if (a.dataset.mod === activeMod) a.classList.add('active');
    });
  }

  _bindHandlers() {
    this.querySelector('#logout')?.addEventListener('click', () => signOut());
  }
}
customElements.define('zzy-header', ZzyHeader);
